/**
 * @generated SignedSource<<11119a36d9ae1e5ca9d88647770b7ba8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type singleLineText_issueFieldSingleLineTextInlineEditFull_SingleLineTextInlineEditViewWithIsEditable_fragmentRef$data = {
  readonly id: string;
  readonly name: string;
  readonly text: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"singleLineText_issueFieldSingleLineTextReadviewFull_SingleLineTextReadView">;
  readonly " $fragmentType": "singleLineText_issueFieldSingleLineTextInlineEditFull_SingleLineTextInlineEditViewWithIsEditable_fragmentRef";
};
export type singleLineText_issueFieldSingleLineTextInlineEditFull_SingleLineTextInlineEditViewWithIsEditable_fragmentRef$key = {
  readonly " $data"?: singleLineText_issueFieldSingleLineTextInlineEditFull_SingleLineTextInlineEditViewWithIsEditable_fragmentRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"singleLineText_issueFieldSingleLineTextInlineEditFull_SingleLineTextInlineEditViewWithIsEditable_fragmentRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "singleLineText_issueFieldSingleLineTextInlineEditFull_SingleLineTextInlineEditViewWithIsEditable_fragmentRef",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "singleLineText_issueFieldSingleLineTextReadviewFull_SingleLineTextReadView"
    },
    {
      "kind": "ScalarField",
      "name": "text"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    }
  ],
  "type": "JiraSingleLineTextField"
};

(node as any).hash = "74b3b1d0f4c945c24e06698b00d25032";

export default node;
